@if (CompanyVendor && Vendor) {
  <div class="container-fluid">
    <div class="row py-2">
      <div class="col">
        <h2>
          My Vendor - {{ Vendor.legalName }}
          @if (!VendorId) {
            <span class="ps-3">
              <a (click)="editVendor()" class="vive-blue cursor-select"
                ><i class="bi bi-pencil-square"></i
              ></a>
            </span>
          }
        </h2>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6"></div>
      @if (Vendor && settingsAndFindingsResults) {
        <div class="col-6">
          <h2 class="text-center">Compliance Details</h2>
        </div>
      }
    </div>
    <div class="row g-2">
      <div class="col-12 col-md-6">
        <div class="row">
          <app-display-card>
            <div class="container inner-panel rounded">
              @if (isVendor(Vendor) && (Vendor.logo || logoUrl)) {
                <div class="row py-2">
                  <div class="col-12">
                    <div class="logo h-100" style="max-width: 200px">
                      <img src="{{ logoUrl ?? Vendor.logo }}" alt="" />
                    </div>
                  </div>
                </div>
              }
              <div class="row py-2">
                <div class="col-12 col-md-6">
                  <div class="row py-2">
                    <div class="col-4 fw-semibold">Legal Name:</div>
                    <div class="col-6">{{ Vendor.legalName }}</div>
                  </div>
                  <div class="row py-2">
                    <div class="col-4 fw-semibold">DBA:</div>
                    <div class="col-6">{{ Vendor.dba }}</div>
                  </div>
                  @if (canShowTier()) {
                    <div class="row py-2">
                      <div class="col-4 fw-semibold">Tier:</div>
                      <div class="col-6">
                        {{ CompanyVendor.vendorRiskLevel || '' }}
                      </div>
                    </div>
                  }
                  @if (canShowComplianceType()) {
                    <div class="row py-2">
                      <div class="col-4 fw-semibold">Compliance Type:</div>
                      <div class="col-6">
                        {{ complianceTypeDisplay() }}
                      </div>
                    </div>
                  }
                </div>
                <div class="col-12 col-md-6">
                  <div class="row py-2">
                    <div class="col-4 fw-semibold">Primary Contact:</div>
                    @if (primaryContact) {
                      <div class="col-6">
                        {{
                          (primaryContact.firstName || '') +
                            ' ' +
                            (primaryContact.lastName || '') || ''
                        }}
                      </div>
                    }
                  </div>
                  @if (primaryContact && primaryContact.email) {
                    <div class="row py-2">
                      <div class="col-4 fw-semibold">
                        Primary Contact Email:
                      </div>
                      <div class="col-8 p-0">
                        <app-email-container
                          [email]="primaryContact.email"
                        ></app-email-container>
                      </div>
                    </div>
                  }
                  <div class="row py-2">
                    <div class="col-4 fw-semibold">Office Phone:</div>
                    <div class="col-6">
                      {{ formatOfficePhone(Vendor.phone) }}
                    </div>
                  </div>
                  @if (
                    CompanyVendor.Company &&
                    CompanyVendor.Company.ApConfigs &&
                    !isVendorAndSitesManager()
                  ) {
                    @for (
                      apConfig of CompanyVendor.Company.ApConfigs;
                      track apConfig.id
                    ) {
                      @if (apConfig.apSystem === 'eUnify') {
                        <div class="row py-2">
                          <div class="col-4 fw-semibold">1099 Vendor?:</div>
                          <div class="col-6">
                            @if (vendorType(Vendor) === 'Vendor') {
                              <input
                                id="issue1099"
                                type="checkbox"
                                class="form-check-input"
                                [(ngModel)]="CompanyVendor.issue1099"
                                (change)="saveCompanyVendor()"
                              />
                            } @else {
                              {{ getIssue1099Display() }}
                            }
                          </div>
                        </div>
                      }
                    }
                  }
                </div>
              </div>
              <hr />
              @if (Vendor.StreetAddress) {
                <div class="row align-items-center">
                  <div class="col-4">
                    <label>Address: </label>
                  </div>
                  <div class="col">
                    <span>{{ formatAddress(Vendor.StreetAddress) }}</span>
                  </div>
                </div>
              }
              @if (Vendor.MailingAddress) {
                <hr />
                <div class="row align-items-center">
                  <div class="col-4">
                    <label>Mailing Address: </label>
                  </div>
                  <div class="col">
                    <span>{{ formatAddress(Vendor.MailingAddress) }}</span>
                  </div>
                </div>
              }
              @if (Vendor.RemitToAddress) {
                <hr />
                <div class="row align-items-center">
                  <div class="col-4">
                    <label>Remit Address: </label>
                  </div>
                  <div class="col">
                    <span>{{ formatAddress(Vendor.RemitToAddress) }}</span>
                  </div>
                </div>
              }
            </div>
          </app-display-card>
        </div>
        <div class="row my-2">
          <app-display-card>
            <div class="container inner-panel rounded">
              <div class="row">
                <div class="col-12">
                  <div class="row py-2">
                    <div class="col-2 fw-semibold">Trades:</div>
                    <div class="col-10">{{ tradesConcatenated }}</div>
                  </div>
                  @if (usesSpotlightVendors) {
                    <div class="row py-2">
                      <div class="col-2 fw-semibold">Spotlight Vendor:</div>
                      <div class="col-10">
                        {{ preferredStatus || 'N/A' }}
                      </div>
                    </div>
                  }
                  <div class="row py-2">
                    <div class="col-2 fw-semibold">Vendor Rating:</div>
                    @if (CompanyVendor.overallVendorRating) {
                      <div class="col-10 justify-content-center">
                        <app-star-rating
                          [rating]="CompanyVendor.overallVendorRating"
                          [readonly]="true"
                          [size]="14"
                        ></app-star-rating>
                      </div>
                    }
                  </div>
                  <div class="row py-2">
                    <div class="col-2 fw-semibold">Website:</div>
                    <div class="col-10">{{ Vendor.website }}</div>
                  </div>
                  @if (VendorId && isVendor(Vendor)) {
                    <div class="row py-2">
                      <div class="col-2 fw-semibold">Approved States:</div>
                      <div class="col-10">
                        {{ vendorTradeStatesConcatenated }}
                      </div>
                    </div>
                    <div class="row py-2">
                      <div class="col-2 fw-semibold">Service Area:</div>
                      <div class="col-10">{{ Vendor.serviceArea }}</div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </app-display-card>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row g-2">
          <div
            class="compliance-details-column"
            [ngClass]="
              shouldShowRegistrationProgress() ? 'col-12 col-md-8' : 'col-12'
            "
          >
            <div class="compliance-details-stack">
              <div class="vive-status compliance-details-card">
                <app-display-card [panelHeight]="'fit'">
                  <h3 class="text-center">VIVE Status</h3>
                  <div
                    class="inner-panel rounded d-flex flex-column align-items-center gap-2"
                  >
                    <div class="fs-24 chip-host" appStatusStyleChanges>
                      {{
                        CompanyVendor.viveStatus +
                          (CompanyVendor.viveSubStatus
                            ? ' - ' + CompanyVendor.viveSubStatus
                            : '')
                      }}
                    </div>
                  </div>
                </app-display-card>
              </div>
              <!-- VPDW-4323: the payment card. It sits directly under VIVE Status
                   because its job is to explain that status: a client seeing
                   "Suspended - No Renewal - Payment" previously had nothing on the
                   page connecting it to a missed renewal, so the first move was a
                   support ticket.

                   The unlabelled "Renewal Date:" row that used to live in the card
                   above was THIS value (CompanyVendor.renewalDate, the payment
                   renewal). It moved here rather than being duplicated — showing
                   one date under two names on one page is the exact confusion
                   VPDW-4239/4240 fixed for staff.

                   Both labels are the names the VENDOR is shown for these two
                   obligations ("Annual Subscription Renewal" in the Payment Hub,
                   "Annual Business Profile Update" at /vendor/renewal), so a
                   client and a vendor discussing one use the same words. The
                   staff card's "This client" / "All clients" scope pills are
                   deliberately absent: a client only ever sees their own
                   relationship, so one is a tautology and the other advertises a
                   cross-client view they have no business seeing. -->
              @if (shouldShowPaymentCard) {
                <div class="payment-standing mt-2 compliance-details-card">
                  <app-display-card [panelHeight]="'fit'">
                    <h3 class="text-center">Payment &amp; renewals</h3>
                    <div class="inner-panel rounded">
                      @if (paymentStanding === 'registration') {
                        <!-- AC5: this story is about the post-registration view.
                             The app-registration-tracker alongside already owns
                             the payment step while registration is open, and two
                             payment narratives on one page would contradict each
                             other. -->
                        <div class="text-secondary fs-14 text-center">
                          Registration in progress. Payment standing appears
                          once this vendor finishes registering for your
                          account.
                        </div>
                      } @else {
                        <dl class="payment-rows">
                          <div class="payment-row">
                            <dt>Standing</dt>
                            <dd>
                              @if (paymentStandingChipClass) {
                                <span
                                  class="chip"
                                  [class]="paymentStandingChipClass"
                                  >{{ paymentStandingLabel }}</span
                                >
                              } @else {
                                <span class="payment-standing-ok">
                                  <span class="vmark" aria-hidden="true"></span>
                                  {{ paymentStandingLabel }}
                                </span>
                              }
                            </dd>
                          </div>
                          <div class="payment-row">
                            <dt>Last paid</dt>
                            <dd>
                              @if (CompanyVendor.vendorLastDatePaid) {
                                <span class="payment-date">{{
                                  CompanyVendor.vendorLastDatePaid
                                    | date: 'MM/dd/y'
                                }}</span>
                              } @else {
                                <!-- AC8: never a blank field, and never a
                                     "not paid" the data cannot support. -->
                                <span class="payment-empty"
                                  >No payment on record</span
                                >
                              }
                            </dd>
                          </div>
                          <div class="payment-row">
                            <dt>Annual Subscription Renewal</dt>
                            <dd>
                              @if (CompanyVendor.renewalDate) {
                                <span class="payment-date">{{
                                  CompanyVendor.renewalDate | date: 'MM/dd/y'
                                }}</span>
                              } @else {
                                <span class="payment-empty">&mdash;</span>
                              }
                            </dd>
                          </div>
                          <div class="payment-row">
                            <dt>Annual Business Profile Update</dt>
                            <dd>
                              @if (CompanyVendor.infoRenewalDueDate) {
                                <span class="payment-date">{{
                                  CompanyVendor.infoRenewalDueDate
                                    | date: 'MM/dd/y'
                                }}</span>
                              } @else {
                                <span class="payment-empty">&mdash;</span>
                              }
                              @if (infoRenewalChipLabel) {
                                <span
                                  class="chip"
                                  [class]="infoRenewalChipClass"
                                  >{{ infoRenewalChipLabel }}</span
                                >
                              }
                            </dd>
                          </div>
                        </dl>
                        @if (paymentExplanation) {
                          <div class="payment-note text-secondary fs-14">
                            @switch (paymentExplanation) {
                              @case ('suspendedForPayment') {
                                Suspended on
                                {{ CompanyVendor.statusDate | date: 'MM/dd/y' }}
                                because this vendor's Annual Subscription
                                Renewal was not paid.
                              }
                              @case ('suspendedForVendorInfo') {
                                Suspended on
                                {{ CompanyVendor.statusDate | date: 'MM/dd/y' }}
                                because this vendor's Annual Business Profile
                                Update is overdue.
                                @if (paymentStanding === 'current') {
                                  Their subscription for your account is paid
                                  and current.
                                }
                              }
                              @case ('overdue') {
                                Their Annual Subscription Renewal was due
                                {{
                                  CompanyVendor.renewalDate | date: 'MM/dd/y'
                                }}.
                              }
                              @case ('feeWaived') {
                                VIVE has waived this vendor's fee for your
                                account &mdash; no payment is expected.
                              }
                              @case ('noRecord') {
                                No payment on record for your account.
                              }
                              @case ('unconfirmed') {
                                Payment status is being confirmed.
                              }
                            }
                          </div>
                        }
                      }
                    </div>
                  </app-display-card>
                </div>
              }
              @if (
                ClientRegisteredVendorId &&
                CompanyVendor.viveStatus === 'Business Verified'
              ) {
                <div class="client-registered-vendor-compliance mt-3">
                  <app-display-card>
                    <div class="inner-panel rounded">
                      <app-client-registered-vendor-compliance
                        (companyVendorChanged)="setCompanyVendor($event)"
                      ></app-client-registered-vendor-compliance>
                    </div>
                  </app-display-card>
                </div>
              }
              @if (
                CompanyVendor &&
                VendorId &&
                CompanyVendor.Company?.fullServiceOffsite &&
                CompanyVendor.Company?.fullServiceOnsite
              ) {
                <div class="owner-verification mt-2">
                  <app-display-card [panelHeight]="'fill'">
                    <h3 class="text-center">Owner Verification</h3>
                    <div
                      class="inner-panel rounded d-flex flex-column align-items-center"
                    >
                      <div class="fs-24" appStatusStyleChanges>
                        {{
                          CompanyVendor.OwnerComplianceProgress?.status ||
                            'Not Started'
                        }}
                      </div>
                    </div>
                  </app-display-card>
                </div>
              }
              @if (settingsAndFindingsResults) {
                <div class="company-background mt-2 compliance-details-card">
                  <app-display-card [panelHeight]="'fill'">
                    <h3 class="text-center">Company Background</h3>
                    <div class="inner-panel rounded">
                      @if (
                        !CompanyVendor.isUsingNewBusinessVerification &&
                        CompanyVendor.country === 'US'
                      ) {
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.companyInGoodStanding
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Company In Good Standing'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.companyInGoodStanding
                              )
                            "
                            [settings]="
                              $safeNavigationMigration(
                                ComplianceSetting?.companyInGoodStanding
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.companyInGoodStanding!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.companyIdentity
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Corporate Identity Check'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.companyIdentity
                              )
                            "
                            [settings]="
                              settingsAndFindingsResults.settings
                                .companyIdentity!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings
                                .companyIdentity!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.companyWatchlist
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Corporate Watchlist'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.companyWatchlist
                              )!
                            "
                            [settings]="
                              getWatchlistValue(
                                settingsAndFindingsResults.settings
                                  .companyWatchlist!
                              )
                            "
                            [findings]="
                              getWatchlistValue(
                                settingsAndFindingsResults.findings
                                  .companyWatchlist!
                              )
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.w9Check
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'W-9 Check'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.w9Check
                              )
                            "
                            [settings]="
                              settingsAndFindingsResults.settings.isW9Checked!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings.w9Check!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.bankruptcy
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Corporate Bankruptcy Search'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.bankruptcy
                              )
                            "
                            [settings]="
                              getBankruptcyValue(
                                settingsAndFindingsResults.settings.bankruptcy!
                              )
                            "
                            [findings]="
                              getBankruptcyValue(
                                settingsAndFindingsResults.findings.bankruptcy!
                              )
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              BusinessInfoResults?.companyLiens
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Corporate Liens & Judgements'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.companyLiens
                              )
                            "
                            [settings]="
                              settingsAndFindingsResults.settings.companyLiens!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings.companyLiens!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                      }
                      @if (
                        CompanyVendor.isUsingNewBusinessVerification &&
                        CompanyVendor.country === 'US'
                      ) {
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.secretaryOfStateResults
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'In Good Standing with SOS?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.secretaryOfStateResults
                              )
                            "
                            [settings]="
                              $safeNavigationMigration(
                                BusinessComplianceSetting?.secretaryOfState
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings
                                .companySecretaryOfState!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.businessVerifiedResults
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Business Verified?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.businessVerifiedResults
                              )
                            "
                            [settings]="
                              $safeNavigationMigration(
                                BusinessComplianceSetting?.businessVerified
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings
                                .companyBusinessVerified!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.governmentWatchlistResults
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Watchlists?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.governmentWatchlistResults
                              )!
                            "
                            [settings]="
                              getWatchlistValue(
                                $safeNavigationMigration(
                                  BusinessComplianceSetting?.governmentWatchlist
                                )!
                              )
                            "
                            [findings]="
                              getWatchlistValue(
                                settingsAndFindingsResults.findings
                                  .companyGovernmentWatchlist!
                              )
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.w9Results
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'W-9 Accepted?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.w9Results
                              )
                            "
                            [settings]="
                              $safeNavigationMigration(
                                BusinessComplianceSetting?.isW9Checked
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings.companyW9Check
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.bankruptcyResults
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Bankruptcies?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.bankruptcyResults
                              )
                            "
                            [settings]="
                              getBankruptcyValue(
                                $safeNavigationMigration(
                                  BusinessComplianceSetting?.bankruptcy
                                )!
                              )
                            "
                            [findings]="
                              getBankruptcyValue(
                                settingsAndFindingsResults.findings
                                  .companyBankruptcy!
                              )
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                        @if (
                          checkIfRequired(
                            $safeNavigationMigration(
                              NewBusinessInfoResults?.lienResults
                            )
                          )
                        ) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Liens & Judgements?'"
                            [result]="
                              $safeNavigationMigration(
                                NewBusinessInfoResults?.lienResults
                              )
                            "
                            [settings]="
                              $safeNavigationMigration(
                                BusinessComplianceSetting?.liens
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.findings
                                .companyLiensAndJudgments!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                      }
                      @if (
                        !CompanyVendor.isUsingNewBusinessVerification &&
                        CompanyVendor.country === 'CA'
                      ) {
                        @if (!!ComplianceSetting?.companyIdentity) {
                          <app-specific-vendor-compliance-finding-dropdown
                            [title]="'Business Name & GST/HST Verified'"
                            [result]="
                              $safeNavigationMigration(
                                BusinessInfoResults?.companyIdentity
                              )!
                            "
                            [settings]="
                              $safeNavigationMigration(
                                ComplianceSetting?.companyIdentity
                              )!
                            "
                            [findings]="
                              settingsAndFindingsResults.companyIdentity!
                            "
                            [componentType]="'companyBackground'"
                          ></app-specific-vendor-compliance-finding-dropdown>
                        }
                      }
                    </div>
                  </app-display-card>
                </div>
              }
              @if (settingsAndFindingsResults) {
                <div class="company-background mt-2 compliance-details-card">
                  <app-display-card [panelHeight]="'fill'">
                    <div class="row">
                      <div class="col">
                        <h3 class="text-center">Trade Licenses</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="inner-panel rounded d-flex flex-column align-items-center gap-2"
                        >
                          <div class="fs-24 chip-host" appStatusStyleChanges>
                            {{
                              TradeLicenseComplianceProgress?.status ||
                                'UNDER REVIEW'
                            }}
                          </div>
                          @if (
                            TradeLicenseComplianceProgress?.subStatus ===
                            'No Licensed Trades'
                          ) {
                            <div class="text-secondary fs-14">
                              No license requirements
                            </div>
                          } @else if (
                            TradeLicenseComplianceProgress?.subStatus
                          ) {
                            <div class="text-secondary fs-14">
                              {{ TradeLicenseComplianceProgress?.subStatus }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </app-display-card>
                </div>
              }
              @if (settingsAndFindingsResults) {
                <div class="insurance-policies mt-2 compliance-details-card">
                  <app-display-card [panelHeight]="'fit'">
                    <h3 class="text-center">Insurance Policies</h3>
                    <div class="inner-panel rounded">
                      @if (
                        settingsAndFindingsResults.settings
                          .generalLiability_isRequired &&
                        hasRequiredResults(generalLiabilities)
                      ) {
                        <app-specific-vendor-compliance-finding-dropdown
                          [title]="'General Liability'"
                          [findingsAndSetting]="generalLiabilities"
                          [componentType]="'insurancePolicies'"
                        ></app-specific-vendor-compliance-finding-dropdown>
                      }
                      @if (
                        settingsAndFindingsResults.settings
                          .umbrellaLiability_isRequired &&
                        hasRequiredResults(umbrellaLiabilities)
                      ) {
                        <app-specific-vendor-compliance-finding-dropdown
                          [title]="'Umbrella Liability'"
                          [findingsAndSetting]="umbrellaLiabilities"
                          [componentType]="'insurancePolicies'"
                        ></app-specific-vendor-compliance-finding-dropdown>
                      }
                      @if (
                        settingsAndFindingsResults.settings
                          .autoLiability_isRequired &&
                        hasRequiredResults(autoLiabilities)
                      ) {
                        <app-specific-vendor-compliance-finding-dropdown
                          [title]="'Commercial Automotive Liability'"
                          [findingsAndSetting]="autoLiabilities"
                          [componentType]="'insurancePolicies'"
                        ></app-specific-vendor-compliance-finding-dropdown>
                      }
                      @if (
                        settingsAndFindingsResults.settings
                          .workersCompensation_isRequired &&
                        hasRequiredResults(workersComp)
                      ) {
                        <app-specific-vendor-compliance-finding-dropdown
                          [title]="'Workers\' Compensation'"
                          [findingsAndSetting]="workersComp"
                          [componentType]="'insurancePolicies'"
                        ></app-specific-vendor-compliance-finding-dropdown>
                      }
                      @if (
                        settingsAndFindingsResults.settings
                          .errorsAndOmissions_isRequired &&
                        hasRequiredResults(professionalLiabilities)
                      ) {
                        <app-specific-vendor-compliance-finding-dropdown
                          [title]="'Professional Liability'"
                          [findingsAndSetting]="professionalLiabilities"
                          [componentType]="'insurancePolicies'"
                        ></app-specific-vendor-compliance-finding-dropdown>
                      }
                    </div>
                  </app-display-card>
                </div>
              }
            </div>
          </div>
          @if (
            shouldShowRegistrationProgress() &&
            VendorId &&
            settingsAndFindingsResults
          ) {
            <div class="col-12 col-md-4 registration-progress-column">
              <app-registration-tracker
                [CompanyIds]="[CompanyId]"
                [VendorId]="VendorId"
                [registrationType]="'CompanyVendor'"
                [excludedSteps]="excludedRegistrationSteps"
                [forceCompleteSteps]="forceCompleteRegistrationSteps"
                [paymentType]="registrationType"
                [disableView]="true"
              ></app-registration-tracker>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
